module.exports = __webpack_public_path__ + "static/Genes1-d17badc229e6fddc72e8658900f53e8d.png";